<template>
  <div>
    <el-image :src="require('@/assets/img/s_top_04.png')"></el-image>
  </div>
  <el-image :src="require('@/assets/img/bj_ej.png')" style="z-index: -100;position: absolute;"></el-image>
  <div class="bodyDiv">
    <div style="margin-right: 0">
      <!--      传来的参数id值是{{id}}中英文状态：{{lan=="中文"?"你好":'hello'}}-->
      <el-breadcrumb separator="/" class="breadcrumb" style="--el-color-primary: #D71634;">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t("Nav.sy") }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">{{ $t("Nav.xwzx") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div>

      <div>

        <span v-html="infoEN">

        </span>
        <div v-if="lan=='zh'">

         <span v-html="info.content"></span>
        </div>
        <div v-else>

        </div>
      </div>

      <div class="backDiv">
        <el-button size="large" @click="doBack">{{ $t("Comm.back") }}</el-button>
      </div>
    </div>
  </div>

</template>

<script setup>
import {ref, toRef, computed, reactive, onMounted} from 'vue'
import {useI18n} from 'vue-i18n'//要在js中使用国际化
import {useStore} from 'vuex'
// import router from "../../router";
import {useRouter} from "vue-router";

const {locale} = useI18n()
const store = useStore()  // 该方法用于返回store 实例

const router = useRouter();

const info = store.state.detail
console.log(info)
const infoEN = ""
let lan = computed(() => {
  return locale.value
})


function handleSelect(keyPath) {
  store.state.keyPath = keyPath;
}

function doBack() {
  // router.back()
  router.go(-1)
}


onMounted(() => {
  console.log(`the component is now mounted.`)
  // const year = router.currentRoute.value.query.id
  // const year = router.query.id;
  const year = router.currentRoute.value.params.id
  console.log(`接收到的参数：` + year)
})

</script>

<style scoped>


</style>
